import { fadeInAnimationLong, fadeInAnimationShort, styles } from 'consts';
import styled from 'styled-components';

const { animationLong, animationShort, white, primaryBlack, primaryRedDarker, fontMBank } = styles;

export const CancelScreenContainer = styled.div<{ isLoading: boolean; height: number }>`
  border-radius: 0.5rem;
  background: ${white};
  text-align: center;
  color: ${white};
  padding: 3.3125rem;

  ${props =>
    props.isLoading &&
    ` padding: 0;
      height: ${props.height}px;
  `}

  .cancel-screen__recovery-payment-button {
    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;

export const CancelScreenWrapper = styled.div`
  animation: ${animationShort};
  ${fadeInAnimationShort};
`;

export const CancelScreenStatus = styled.div`
  max-width: 25rem;
  margin: 0 auto;
  font-size: 2rem;
  line-height: 1.25;
  text-align: center;
  color: ${primaryBlack};
`;

export const CancelScreenStatusText = styled.div`
  max-width: 25rem;
  margin: 0 auto;
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.25;
  text-align: center;
  color: ${primaryRedDarker};
  margin-bottom: 1.5rem;
`;

export const CancelScreenIcon = styled.div`
  animation: ${animationLong};
  ${fadeInAnimationLong};
  img {
    width: 12.5rem;
    height: 9.375rem;
  }
  margin-bottom: 0.5rem;
`;

export const CancelScreenMessage = styled.div`
  color: ${primaryBlack};
  font-family: ${fontMBank};
  font-size: 1.375rem;
  line-height: 1.32;
  max-width: 25rem;
  margin: 0 auto;
`;
